import { render, staticRenderFns } from "./CardCategories.vue?vue&type=template&id=1ed1afec&"
import script from "./CardCategories.vue?vue&type=script&lang=js&"
export * from "./CardCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports